export default __webpack_public_path__ + "static/media/zodiacToto-Horse.0752b734.png";